import { RegistrationStatus } from '@/types/registration'

/**
 * True when the registration has ended and released its place (cancelled or
 * payment expired). Mirrors RegistrationStatus::released() in the API.
 */
export function isReleasedRegistrationStatus(status: string): boolean {
  return status === RegistrationStatus.Cancelled || status === RegistrationStatus.PaymentExpired
}
